import React from "react";

import { MultiOffers } from "@data-types/bet-booster/MultiOffers";
import BetBuilderPicksOfferDisplay from "./BetBuilderPicksOfferDisplay";

export function BetBuilderPicksOfferTips(props: {
	multiOffers: MultiOffers[];
	maxOffers?: number;
	isPopup?: boolean;
	isWrapped?: boolean;
}) {
	const offerList = props.maxOffers
		? props.multiOffers.slice(0, props.maxOffers)
		: props.multiOffers;
	return (
		<>
			{offerList.map((offer, index: number) => {
				return (
					<BetBuilderPicksOfferDisplay
						key={offer.bettingOfferId}
						offer={offer}
						isLast={index == props.multiOffers.length - 1}
						isPopup={props.isPopup}
						isWrapped={props.isWrapped}
					/>
				);
			})}
		</>
	);
}
